<template>
  <el-form class="voice-setting-form" label-position="top" size="mini">
    <el-form-item class="voice-setting voice-name" label="发音人:">
      <el-select v-model="value.name" filterable @change="handleNameChanged">
        <el-option v-for="item in config.langugages" :key="item.id" :label="item.name" :value="item.id">
          <span style="float: left">{{ item.name }}</span>
          <span style="float: right; color: #8492a6; font-size: 13px; padding-left: 12px;">{{ item.labels }}</span>
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item class="voice-setting voice-roles" v-show="roles" label="角色扮演:">
      <el-select v-model="value.role" filterable>
        <el-option key="default" label="默认" value="default"></el-option>
        <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item class="voice-setting voice-styles" v-show="styles" label="说话风格:">
      <el-select v-model="value.style" filterable @change="handleStyleChanged">
        <el-option key="default" label="默认" value="default"></el-option>
        <el-option v-for="item in styles" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item class="voice-setting voice-styledegree" v-show="value.style != 'default'" label="风格强度:">
      <el-input-number v-model="value.styledegree" :precision="2" :step="0.01" :min="0.01" :max="2"></el-input-number>
    </el-form-item>

    <el-form-item class="voice-setting prosody-rate" label="更改语速:">
      <el-select v-model="value.rate" allow-create filterable default-first-option placeholder="+30.00%|-30.00%|预定义值">
        <el-option v-for="item in rateOpts" :key="item.id" :label="item.desc" :value="item.id"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item class="voice-setting prosody-volume" label="更改音量:">
      <el-select v-model="value.volume" allow-create filterable default-first-option placeholder="+30.00%|-30.00%|预定义值">
        <el-option v-for="item in volumeOpts" :key="item.id" :label="item.desc" :value="item.id"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item class="voice-setting prosody-pitch" label="更改音高:">
      <el-select v-model="value.pitch" allow-create filterable default-first-option placeholder="600Hz|+80Hz|-20Hz|-2st|预定义值">
        <el-option v-for="item in pitchOpts" :key="item.id" :label="item.desc" :value="item.id"></el-option>
      </el-select>
    </el-form-item>

  </el-form>
</template>

<script>
import config from "./config";

export default {
  name: "ssmlsetting",
  props: {
    value: Object
  },
  data() {
    return {
      config,
      pitchOpts: [
        {id: 'x-low', desc: '超低'},
        {id: 'low', desc: '低'},
        {id: 'medium', desc: '中等'},
        {id: 'high', desc: '高'},
        {id: 'x-high', desc: '超高'},
        {id: 'default', desc: '默认'},
        {id: '+30Hz', desc: '+30Hz'},
        {id: '+20Hz', desc: '+20Hz'},
        {id: '+10Hz', desc: '+10Hz'},
        {id: '-10Hz', desc: '-10Hz'},
        {id: '-20Hz', desc: '-20Hz'},
        {id: '-30Hz', desc: '-30Hz'},
      ],
      rateOpts: [
        {id: 'x-slow', desc: '超慢'},
        {id: 'slow', desc: '慢'},
        {id: 'medium', desc: '中等'},
        {id: 'fast', desc: '快'},
        {id: 'x-fast', desc: '超快'},
        {id: 'default', desc: '默认'},
        {id: '+30%', desc: '+30%'},
        {id: '+20%', desc: '+20%'},
        {id: '+10%', desc: '+10%'},
        {id: '-10%', desc: '-10%'},
        {id: '-20%', desc: '-20%'},
        {id: '-30%', desc: '-30%'},
      ],
      volumeOpts: [
        {id: 'silent', desc: '静音'},
        {id: 'x-soft', desc: '超轻'},
        {id: 'soft', desc: '轻'},
        {id: 'medium', desc: '中等'},
        {id: 'loud', desc: '大声'},
        {id: 'x-loud', desc: '超大声'},
        {id: 'default', desc: '默认'},
        {id: '+30%', desc: '+30%'},
        {id: '+20%', desc: '+20%'},
        {id: '+10%', desc: '+10%'},
        {id: '-10%', desc: '-10%'},
        {id: '-20%', desc: '-20%'},
        {id: '-30%', desc: '-30%'},
      ]
    };
  },
  computed: {
    language() {
      if (this.value && this.value.name) {
        return config.langugages.find((n) => n.id == this.value.name);
      }
      return null;
    },
    styles() {
      return this.getOptions('styles');
    },
    roles() {
      return this.getOptions('roles');
    },
  },
  methods: {
    getOptions(key) {
      if (this.language && this.language[key]) {
        const names = typeof this.language[key] === "string" ? this.language[key].split("|") : Object.keys(config[key]);
        return names.map((s) => {
          return { id: s, ...config[key][s] };
        });
      }
      return null;
    },
    handleNameChanged() {
      if (this.value) {
        Object.assign(this.value, {
          style: "default",
          role: "default",
        })
      }
    },
    handleStyleChanged() {
      if (this.value && this.value.style === 'default') {
        Object.assign(this.value, {
          styledegree: 1,
        })
      }
    }
  },
};
</script>

<style lang="scss">
.voice-setting-form {
  label.el-form-item__label {
    line-height: 1;
    padding-bottom: 6px;
  }
  .el-form-item {
    margin-bottom: 0;
    + .el-form-item {
      margin-top: 12px;
    }
  }
}
</style>